const pad2 = (number: number): string => (number < 10 ? "0" : "") + number;

export default pad2;
